import BASE_URL from "./baseUrl";
import CryptoJS from "crypto-js";

const SECRET_KEY = "A9F3KxQW7MZ2LrP8EJHnD4sVY0T6mB5C";
const LOGIN_SECRET = "sk53c906cbfcd242af8615f0c776a522e7vacdm";


function decryptToken(text) {


  if (!text) return null;

  try {
  

  
    const decoded = decodeURIComponent(text);
  

    const bytes = CryptoJS.AES.decrypt(decoded, LOGIN_SECRET);
    const originalText = bytes.toString(CryptoJS.enc.Utf8);

 

    if (!originalText) {
    
      return null;
    }

    return JSON.parse(originalText);

  } catch (error) {
    
    return null;
  }
}

function encryptLoginId(loginId) {


  const iv = CryptoJS.lib.WordArray.random(16);

  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(loginId),
    CryptoJS.enc.Utf8.parse(SECRET_KEY),
    {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  const result = {
    iv: CryptoJS.enc.Base64.stringify(iv),
    payload: encrypted.toString(),
  };

  return result;
}


export function testEncryptLoginId() {

}

function showCustomAlert(title, message, redirectUrl) {

  const existingAlert = document.getElementById("custom-alert-overlay");
  if (existingAlert) {
    existingAlert.remove();
  }

  const alertDiv = document.createElement("div");
  alertDiv.id = "custom-alert-overlay";

  alertDiv.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999;
    font-family: Arial, sans-serif;
  `;

  const modal = document.createElement("div");
  modal.style.cssText = `
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    text-align: center;
    min-width: 280px;
  `;

  const titleElement = document.createElement("h3");
  titleElement.style.cssText = "color: #d32f2f; margin-bottom: 10px;";
  titleElement.textContent = title;

  const messageElement = document.createElement("p");
  messageElement.style.cssText = "color: #666; margin-bottom: 15px;";
  messageElement.textContent = message;

  const okBtn = document.createElement("button");
  okBtn.id = "custom-alert-ok-btn";
  okBtn.innerText = "OK";

  okBtn.style.cssText = `
    background: #d32f2f;
    color: white;
    border: none;
    padding: 8px 18px;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 10px;
  `;

  okBtn.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    const alertElement = document.getElementById("custom-alert-overlay");

    if (alertElement) {
      alertElement.remove();
    }
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  });

  modal.appendChild(titleElement);
  modal.appendChild(messageElement);
  modal.appendChild(okBtn);

  alertDiv.appendChild(modal);

  document.body.appendChild(alertDiv);
}

export async function initAuth() {

  let token = null;

  const urlParams = window.location.href;
  const urlToken = urlParams.split("token=")[1];

  if (urlToken) {

    token = urlToken;
    localStorage.setItem("AUTH", token);

  } else {

    token = localStorage.getItem("AUTH");
  }

  // No token
  if (!token) {

    showCustomAlert(
      "Access Required",
      "Please login to access this module",
      "https://winedge.taction.in/login"

      //uat
        // "https://winedge.tataaia.taction.in/login"
    );

    return false;
  }

  const decrypted = decryptToken(token);

  // Invalid token
  if (!decrypted) {

    showCustomAlert(
      "Invalid Token",
      "Please login again",
        "https://winedge.taction.in/login"
       
      //uat 
          //  "https://winedge.tataaia.taction.in/login"
    );

    return false;
  }

  let data;

  try {

    data = decrypted;

  } catch (err) {

    return false;
  }

  const encryptedLoginId = encryptLoginId({
    login_id: data.user.login_id,
  });

  try {

    const res = await fetch(`${BASE_URL}/v2/validate_login_id`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${data.token}`,
      },
      body: JSON.stringify({
        payload: encryptedLoginId,
      }),
    });

    const result = await res.json();

    if (result.success) {

      const url = new URL(window.location.href);
      url.searchParams.delete("token");

      window.history.replaceState({}, "", url);

      return true;

    } else {

      showCustomAlert(
        "Unauthorized",
        "Access denied",
         "https://winedge.taction.in/login"
       
      //uat 
          // "https://winedge.tataaia.taction.in/login"
      );

      return false;
    }

  } catch (err) {


    showCustomAlert(
      "Error",
      "Something went wrong. Please login again",

       "https://winedge.taction.in/login"
  
         //uat 
        // "https://winedge.tataaia.taction.in/login"
    );

    return false;
  }
}

function decryptResponse(response) {
  try {
    const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);

   
    if (key.sigBytes !== 16 && key.sigBytes !== 24 && key.sigBytes !== 32) {
  
      return null;
    }

    let encryptedData = response;


    if (typeof encryptedData === 'string') {
      try {
        encryptedData = JSON.parse(encryptedData);
      } catch (e) {
       
        return null;
      }
    }
    
 
    
    if (!encryptedData?.iv || !encryptedData?.payload) {
   
      return null;
    }

    const iv = CryptoJS.enc.Base64.parse(encryptedData.iv);


    let decrypted;
    try {
      decrypted = CryptoJS.AES.decrypt(
        encryptedData.payload,
        key,
        {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
      );
    } catch (e) {
 
 
      try {
        const cipherParams = CryptoJS.lib.CipherParams.create({
          ciphertext: CryptoJS.enc.Base64.parse(encryptedData.payload),
        });
        
        decrypted = CryptoJS.AES.decrypt(
          cipherParams,
          key,
          {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
          }
        );
      } catch (e2) {
      
        return null;
      }
    }

    if (!decrypted || decrypted.sigBytes === 0) {
   
      return null;
    }

  

    const text = decrypted.toString(CryptoJS.enc.Utf8);

    if (!text) {
    
      return null;
    }



    return JSON.parse(text);

  } catch (err) {
  
    return null;
  }
}

async function getCompetitors() {
  try {
 
    const res = await fetch(`${BASE_URL}/v2/competitors`);

    const json = await res.json();


    let competitors = [];

    if (json.iv && json.payload) {
      
      const dec = decryptResponse(json);
   
      competitors = dec?.data?.competitors || [];
    } else {
  
      competitors = json.data?.competitors || [];
    }
    
 
    return competitors;

  } catch (err) {
   
    return [];
  }
}

async function getPolicyOptions() {
  try {
   
    
    const res = await fetch(`${BASE_URL}/v2/get_policy_options`);
    
    if (!res.ok) {
   
      return {};
    }

    const json = await res.json();
   

    let options = {};
    if (json.iv && json.payload) {
    
      const dec = decryptResponse(json);
   
      options = dec?.data || {};
    } else {
   
      options = json.data || {};
    }
    
   
  
    return options;

  } catch (err) {
   
    return {};
  }
}

 async function getFundLogo() {
  try {
    const res = await fetch(`${BASE_URL}/v2/get_fund_logo`);
    if (!res.ok) return null;
  
    const json = await res.json();

    return json.iv ? decryptResponse(json)?.data : json.data;
  } catch {
    return null;
  }
}

async function getFundHero() {
  try {
    const res = await fetch(`${BASE_URL}/v2/get_fund_hero`);
    if (!res.ok) return null;

    const json = await res.json();

    return json.iv ? decryptResponse(json)?.data : json.data;
  } catch {
    return null;
  }
}

async function getFundFooter() {
  try {
    const res = await fetch(`${BASE_URL}/v2/get_fund_footer`);
    if (!res.ok) return null;

    const json = await res.json();

    return json.iv ? decryptResponse(json)?.data : json.data;
  } catch {
    return null;
  }
}

async function getFunds(selectedCompanies) {
  try {
    const rawPayload = {
      competitors: selectedCompanies 
    };


    const iv = CryptoJS.lib.WordArray.random(16);

    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(rawPayload),
      CryptoJS.enc.Utf8.parse(SECRET_KEY),
      {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );


    const requestBody = {
      payload: {
        iv: CryptoJS.enc.Base64.stringify(iv),
        payload: encrypted.toString()
      }
    };


    const res = await fetch(`${BASE_URL}/v2/funds`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    });

    if (!res.ok) {
      return [];
    }

    const json = await res.json();

    let funds = [];

    if (json.iv && json.payload) {
      const dec = decryptResponse(json);
      funds = dec?.data?.competitors || [];
    } else {
      funds = json.data?.competitors || [];
    }


    return funds;

  } catch (e) {
    return [];
  }
}

async function getPolicyComparison(payload) {
  try {
    

    const iv = CryptoJS.lib.WordArray.random(16);

    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(payload),
      CryptoJS.enc.Utf8.parse(SECRET_KEY),
      {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    const encryptedPayload = {
      payload: {
        iv: CryptoJS.enc.Base64.stringify(iv),
        payload: encrypted.toString()
      }
    };

    const res = await fetch(`${BASE_URL}/v2/policy-comparison`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(encryptedPayload),
    });

    if (!res.ok) {
    
      return null;
    }

    const response = await res.json();
   

    if (response.iv && response.payload) {
      const decrypted = decryptResponse(response);
     
      return decrypted;
    }

   
    return response;

  } catch (err) {
   
    return null;
  }
}

async function getPolicyComparisonGraph(payload) {
  try {
    const iv = CryptoJS.lib.WordArray.random(16);

    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(payload),
      CryptoJS.enc.Utf8.parse(SECRET_KEY),
      {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    const encryptedPayload = {
      payload: {
        iv: CryptoJS.enc.Base64.stringify(iv),
        payload: encrypted.toString(),
      }
    };

    const res = await fetch(`${BASE_URL}/v2/policy-comparison-graph`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(encryptedPayload),
    });

    const response = await res.json();

    if (response.iv && response.payload) {
      return decryptResponse(response);
    }

    return response;

  } catch (err) {
   
    return null;
  }
}

async function getFinalSummary(payload) {
  try {
    const iv = CryptoJS.lib.WordArray.random(16);

    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(payload),
      CryptoJS.enc.Utf8.parse(SECRET_KEY),
      {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    const encryptedPayload = {
      payload: {
        iv: CryptoJS.enc.Base64.stringify(iv),
        payload: encrypted.toString()
      }
    };

    const res = await fetch(`${BASE_URL}/v2/final-summary`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(encryptedPayload),
    });

    const response = await res.json();

    if (response.iv && response.payload) {
      return decryptResponse(response);
    }

    return response;

  } catch (err) {
   
    return null;
  }
}

export {
  getCompetitors,
  getFunds,
  getPolicyComparison,
  getPolicyComparisonGraph,
   getFinalSummary,
  getPolicyOptions,
  getFundHero,
  getFundFooter,
  getFundLogo,
  encryptLoginId,




  decryptToken,
  decryptResponse,
  showCustomAlert
};
